export enum BenefitName {
    RECIPE_BOOKLET = 'RECIPE_BOOKLET',
    CERTIFICATE = 'CERTIFICATE',
    WIFI = 'WIFI',
    PRIVATE = 'PRIVATE',
    TOILET = 'TOILET',
    AIR_CONDITION = 'AIR_CONDITION',
    REFRESHMENTS = 'REFRESHMENTS',
    ALCOHOL = 'ALCOHOL',
    SOFT_DRINK = 'SOFT_DRINK',
    COFFEE_AND_TEA = 'COFFEE_AND_TEA',
    WATER = 'WATER',
    SNACKS = 'SNACKS',
    DINNER = 'DINNER',
    LUNCH = 'LUNCH',
    BREAKFAST = 'BREAKFAST',
    ALL_INGREDIENTS = 'ALL_INGREDIENTS',
    COOKING_UTENSILS = 'COOKING_UTENSILS',
    OTHER_EQUIPMENT = 'OTHER_EQUIPMENT',
    SEGWAY = 'SEGWAY',
    TRIKKE = 'TRIKKE',
    SNORKELING_EQUIPMENT = 'SNORKELING_EQUIPMENT',
    SCUBA_EQUIPMENT = 'SCUBA_EQUIPMENT',
    BICYCLE = 'BICYCLE',
    ALL_FEES_AND_TAX = 'ALL_FEES_AND_TAX',
    PARKING_FEES = 'PARKING_FEES',
    GRATUITIES = 'GRATUITIES',
    GST = 'GST',
    AIRPORT_TAX = 'AIRPORT_TAX',
    LANDING_AND_FACILITY_FEES = 'LANDING_AND_FACILITY_FEES',
    FUEL_SURCHARGE = 'FUEL_SURCHARGE',
    OTHER = 'OTHER',
    UNKNOWN = 'UNKNOWN',
}
